export const includeQuestions = (questions: any, newQuestions: any) => {
  return [
    {
      attributeKey: 'address',
      questions: newQuestions,
    },
    {
      attributeKey: 'income',
      questions: newQuestions,
    },
    {
      attributeKey: 'geo_zip_code',
      questions: questions,
    },
    {
      attributeKey: 'household_body_count_under_18',
      questions: questions,
      defaultValue: 0,
    },
    {
      attributeKey: 'household_income',
      questions: questions,
      referenceAttributeKey: 'income',
    },
    {
      attributeKey: 'city',
      questions: questions,
      referenceAttributeKey: 'address',
    },
    {
      attributeKey: 'state',
      questions: questions,
      referenceAttributeKey: 'address',
    },
  ];
};

export const getQuestionFromAllQuestions = (
  questions: any,
  attributeKey: string,
  questionnaireValue: any,
  dependentAttributeKey?: any,
  particularValue?: string,
  defaultValue?: any,
) => {
  const selectedQuestion = questions.find(
    question => question?.attributeKey === attributeKey,
  );

  if (selectedQuestion) {
    const qid = selectedQuestion['questionId'];
    const dependentQuestion = questions.find(
      question => question?.attributeKey === dependentAttributeKey,
    );

    // If there is a dependent question, we use that to get the value
    if (dependentAttributeKey && dependentQuestion) {
      const referenceQuestionId = dependentQuestion['questionId'];
      const value = questionnaireValue[referenceQuestionId];
      if (!questionnaireValue[qid]) {
        return {
          [qid]: (particularValue && value[particularValue]) ?? value,
        };
      }
    } else {
      if (!questionnaireValue[qid]) {
        return {
          [qid]: defaultValue ?? 0,
        };
      }
    }
    return {};
  }

  return {};
};
